module.exports = __webpack_public_path__ + "static/media/e24.530ecfe4.jpg";